import {BannersPartnerConfig} from '../models/banners-partner-config';
import {SalesChannel} from '../consts/sales-channel.enum';
import {StepKey} from '../enums/step-key.enum';
import {BannerKey} from '../../shared/enums/banner-key.enum';

export const BANNERS_CONFIG: BannersPartnerConfig[] = [
    {
        partnerName: SalesChannel.KIOSKPOLIS,
        htmlBannersDisabled: true,
        stepBanners: [
            {
                stepKey: StepKey.FIRST_STEP_0,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_1,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_2,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_3,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.SECOND_STEP,
                bannerKey: BannerKey.ACCIDENTS_HAPPEN
            }
        ],
        offersListBanner: {
            bannerKey: BannerKey.DRIVER_SOS
        },
        paymentBanner: {
            bannerKey: BannerKey.DRIVER_SOS_DETAILS
        }
    },
    {
        partnerName: SalesChannel.BANKIER,
        htmlBannersDisabled: true,
        stepBanners: [
            {
                stepKey: StepKey.FIRST_STEP_0,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_1,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_2,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_3,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.SECOND_STEP,
                bannerKey: BannerKey.ACCIDENTS_HAPPEN
            }
        ],
        offersListBanner: {
            bannerKey: BannerKey.DRIVER_SOS
        },
        paymentBanner: {
            bannerKey: BannerKey.DRIVER_SOS_DETAILS
        }
    },
    {
        partnerName: SalesChannel.MPAY,
        htmlBannersDisabled: true,
        stepBanners: [
            {
                stepKey: StepKey.FIRST_STEP_0,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_1,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_2,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_3,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.SECOND_STEP,
                bannerKey: BannerKey.ACCIDENTS_HAPPEN
            }
        ],
        offersListBanner: {
            bannerKey: BannerKey.DRIVER_SOS
        },
        paymentBanner: {
            bannerKey: BannerKey.DRIVER_SOS_DETAILS
        }
    },
    {
        partnerName: SalesChannel.OLX,
        htmlBannersDisabled: true,
        stepBanners: [
            {
                stepKey: StepKey.FIRST_STEP_0,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_1,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_2,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.FIRST_STEP_3,
                bannerKey: BannerKey.BUY_POLICY
            },
            {
                stepKey: StepKey.SECOND_STEP,
                bannerKey: BannerKey.ACCIDENTS_HAPPEN
            }
        ],
        offersListBanner: {
            bannerKey: BannerKey.DRIVER_SOS
        },
        paymentBanner: {
            bannerKey: BannerKey.DRIVER_SOS_DETAILS
        }
    },
    // {
    //     partnerName: SalesChannel.SKYCASH,
    //     stepBanners: [
    //         {
    //             stepKey: StepKey.FIRST_STEP_1,
    //             bannerKey: BannerKey.BUY_POLICY
    //         },
    //         {
    //             stepKey: StepKey.FIRST_STEP_2,
    //             bannerKey: BannerKey.BUY_POLICY
    //         },
    //         {
    //             stepKey: StepKey.FIRST_STEP_3,
    //             bannerKey: BannerKey.BUY_POLICY
    //         },
    //         {
    //             stepKey: StepKey.SECOND_STEP,
    //             bannerKey: BannerKey.ACCIDENTS_HAPPEN
    //         }
    //     ],
    //     offersListBanner: {
    //         bannerKey: BannerKey.DRIVER_SOS
    //     },
    //     paymentBanner: {
    //         bannerKey: BannerKey.DRIVER_SOS_DETAILS
    //     }
    // }
];
